import "@/app/(public)/_components/marketing/hero/hero.css";
import { HeroSocialFooter } from "@/app/(public)/_components/marketing/hero/sections/hero-social-footer";
import type { ReactElement } from "react";

/** Imprint, privacy and cookie settings for website pages that have no footer of their own. */
export function WebsiteLegalFooter({
  background,
}: {
  readonly background: string;
}): ReactElement {
  return (
    <div style={{ background, padding: "1px 0 48px" }}>
      <HeroSocialFooter showSocialSection={false} />
    </div>
  );
}
